import ImageSlider from './ImageSlider';
import styles from '../styles/Services.module.css';

import gal_1 from '../assets/gal_auto.jpg';
import gal_2 from '../assets/gal_auto_2.jpg';
import gal_3 from '../assets/gal_mot_3.jpg';
import gal_4 from '../assets/gal_mot.jpg';
import gal_5 from '../assets/gal_vespa.jpg';
import gal_6 from '../assets/gal_werk.jpg';

const Gallery = () => {
    const images = [gal_1, gal_2, gal_3, gal_4, gal_5, gal_6];


    return (
        <section className={styles.services} id="services">
            <div>
                <h1>Gallerie</h1>
                <ImageSlider images={images} autoSlide={true} slideInterval={4000} />
            </div>
        </section>
    );
};

export default Gallery;
